import React from 'react';
import type { PricingData } from '../hooks/usePricingData';
import { tierPricing } from '../data/pricing';
interface PricingTiersProps {
  data: PricingData;
}
export function PricingTiers({
  data
}: PricingTiersProps) {
  const {
    tiers,
    priceRow
  } = data;
  const recommendedIndex = tiers.length === 3 ? 1 : -1;
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/[0.08] rounded-3xl overflow-hidden border border-white/[0.08]" data-id="element-65" data-mp="132a31idsaogl">
      {tiers.map((tier, index) => {
      const isRecommended = index === recommendedIndex;
      const details = tierPricing[tier.trim().toLowerCase()];
      // A price column in the CSV always wins over the default
      const price = priceRow?.values[index] || details?.price;
      return <div key={tier} className={`relative px-8 py-10 ${isRecommended ? 'bg-white/[0.015]' : 'bg-black'}`} data-id="element-66" data-mp="kar0fcno9cf3" data-mpi={index}>
            <div className="flex items-center justify-between gap-3 mb-6" data-id="element-67" data-mp="bbdomdc2sbr7">
              <h3 className="text-2xl font-semibold text-white tracking-tight" data-id="element-68" data-mp="3cfygi62t6a5t">
                {tier}
              </h3>
              {isRecommended && <span className="text-[10px] font-medium uppercase tracking-[1.5px] text-zinc-500" data-id="element-69" data-mp="38ed1of6prlsz">
                  Recommended
                </span>}
            </div>

            {price && <div className="mb-5" data-id="element-70" data-mp="3hdi25r1u5p7s">
                <p className="text-4xl font-semibold text-white tracking-tight leading-none" data-id="element-71" data-mp="2toyu9cmp7eg8">
                  {price}
                </p>
                <p className="text-sm text-zinc-500 mt-2 h-5" data-id="element-72" data-mp="2osgsmlmnzw84">
                  {details?.unit ?? ''}
                </p>
              </div>}

            {details?.tagline && <p className="text-sm text-zinc-500 leading-relaxed" data-id="element-73" data-mp="2yn8s5uzt4t5j">
                {details.tagline}
              </p>}
          </div>;
    })}
    </div>;
}